module.exports = __webpack_public_path__ + "static/media/arrow_left.569ee128.svg";